import React from "react";
import ReactDOM from "react-dom";

import Pure from "./pure";

import "./index.scss";

import * as serviceWorker from "./serviceWorker";

import { getAuthToken } from "./actions/account";

import analytics from "./analytics";

// Vendor scripts (jQuery, Bootstrap) loaded via public/scripts.js in index.html

import { Base as base } from "@dwellsocial/dwellsocial-api";

base.setHost(process.env.REACT_APP_API_HOST); // eslint-disable-line

const authToken = getAuthToken();

if (authToken) base.setToken(authToken);

// Defer analytics off the cold-load critical path: wait for window 'load',
// then schedule on first idle. requestIdleCallback alone fired at ~1.7s on
// production (still during cold-load TTI); gating on 'load' first guarantees
// the document, all subresources, and any pending paints are settled before
// fbevents.js / GA / Bing scripts begin downloading.
const scheduleAnalyticsInit = () => {
  if (typeof requestIdleCallback === "function") {
    requestIdleCallback(() => analytics.init(), { timeout: 3000 });
  } else {
    setTimeout(() => analytics.init(), 0);
  }
};

if (document.readyState === "complete") {
  scheduleAnalyticsInit();
} else {
  window.addEventListener("load", scheduleAnalyticsInit, { once: true });
}

document.title = "DwellSocial";

ReactDOM.render(<Pure />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
